<template>
  <div class="receiving-addr-wrap">
    <!-- 引入公共头部 :showBack="true" :showEdit="true"-->
    <dg-header :showBack="true" title="选择收货地址"></dg-header>
    <!-- 选择收货地址列表 -->
    <ul class="addr-wrap">
      <li class="addr-wrap-item" v-for="(item,index) in list" :key="item.id" :index="index">
        <van-radio v-model="radio" checked-color="#d5503f"></van-radio>
        <div class="addr-item-info">
          <p class="addr-item-name">
            {{item.name}}
            <span>{{item.tel}}</span>
          </p>
          <p class="addr-_address">{{item.address}}</p>
        </div>
        <span class="addr-item-edit" @click="jumpEditAddr(item)"></span>
      </li>
    </ul>

    <!-- 底部按钮 -->
    <div class="addr-footer-btn">
      <router-link to="/add-address">
        <button class="button_text" >新增收货地址</button>
      </router-link>
    </div>
  </div>
</template>
<script>
import DgHeader from "@/components/header";

export default {
  data() {
    return {
      radio: "1",
      chosenAddressId: "1",
      list: [
        {
          id: "1",
          name: "张三",
          tel: "13000000000",
          address: "浙江省杭州市西湖区文三路 138 号东方通信大厦 7 楼 501 室"
        },
        {
          id: "2",
          name: "李四",
          tel: "1310000000",
          address: "浙江省杭州市拱墅区莫干山路 50 号"
        }
      ]
    };
  },
  components: {
    DgHeader
  },
  methods: {
    jumpEditAddr () {
      this.$router.push({path: '/add-address'})
    }
  }
};
</script>
<style lang="scss">
.receiving-addr-wrap {
  .addr-wrap {
    width: 100%;
    height: auto;
    padding: 30px 30px 100px;
    box-sizing: border-box;
    .addr-wrap-item {
      width: 100%;
      padding: 40px 30px;
      box-sizing: border-box;
      background: $bg02;
      border-radius: $br30;
      box-shadow: $box-shadow3;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      .van-radio {
        width: 40px;
        line-height: 100%;
        overflow: inherit;
        margin-right: 30px;
        vertical-align: middle;
      }
      .addr-item-info {
        flex: 1;
        overflow: hidden;
        .addr-item-name {
          font-size: 28px;
          color: $fc03;
          > span {
            font-size: 24px;
            color: $fc09;
            margin-left: 10px;
          }
        }
        .addr-_address {
          @include ellipsis();
          font-size: 24px;
          color: $fc09;
          margin-top: 16px;
        }
      }
      .addr-item-edit {
        width: 40px;
        height: 40px;
        background: red;
        background: url("../../../assets/images/edit-icon.png") no-repeat 0 0px/100%;
      }
      .van-address-item__name {
        // font-size: 24px;
        color: $fc06;
      }
    }
  }
  .addr-footer-btn {
    width: 100%;
    background: none;
    padding: 10px 30px;
    box-sizing: border-box;
    border: none;
    position: fixed;
    bottom: 0;
    >a{
      display: inline-block;
      width: 100%;
    }
    .button_text {
      width: 100%;
      line-height: 80px;
      background: $btn02;
      display: inline-block;
      border-radius: $br50;
      font-size: 28px;
      color: $bg02;
      @include resetButton ();
      &:active{
        background: $btnHover02;
      }
    }
  }
  
}
</style>
